import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-2" }
const _hoisted_2 = ["innerHTML"]

import { FormLabel } from './index'


export default /*@__PURE__*/_defineComponent({
  __name: 'FormGroup',
  props: {
    name: {},
    footer: {},
    isRequired: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(FormLabel), {
      name: _ctx.name,
      "is-required": _ctx.isRequired
    }, null, 8, ["name", "is-required"]),
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _renderSlot(_ctx.$slots, "footer"),
    _createElementVNode("p", {
      class: "mt-2 text-sm text-gray-500",
      innerHTML: _ctx.footer
    }, null, 8, _hoisted_2)
  ]))
}
}

})